import { reschedulingStopMessage } from '../../../../notifications/scheduling/rescheduleStop';
import { ProjectStopUnschedulingDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import getAppRoot from '../../utils/getAppRoot';

const projectStopReschedulingHandler = ({
  store, pendingSolution,
}: ProjectStopUnschedulingDtoModelType) => {
  // Only do this for other dispatchers not editing a stop
  if (pendingSolution.assignAction.visitId != null && !getAppRoot(store).ui.orderForm.visible) {
    const id = String(pendingSolution.assignAction.visitId);
    const { visitName } = pendingSolution.assignAction;

    getAppEnv(store).message(reschedulingStopMessage(id, visitName));
  }
};

export default projectStopReschedulingHandler;
